var NotificationBase = require('../NotificationBase');
/* globals jimdoData, diy */
(function() {

    var BrowserUpgradeNotification = NotificationBase.extend({
        /**
         * Default sticky for BrowserUpgradeNotification
         */
        stickyDefault: 1,
        /**
         * Default severity for BrowserUpgradeNotification
         */
        severityDefault: 3,
        /**
         * Default category for BrowserUpgradeNotification
         */
        categoryDefault: 1,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-alert',
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            var payload = this.getPayload();
            return '<span>' +
                jimdoData.messages.upgradeBrowser[payload.msgType] +
                '</span> <a>' +
                jimdoData.messages.upgradeBrowser[payload.browserType].text +
                '</a>';
        },

        globalAction: function() {
            var payload = this.getPayload();
            window.open(jimdoData.messages.upgradeBrowser[payload.browserType].href, '_blank');
        },

        getName: function() {
            return 'BrowserUpgradeNotification';
        }
    });

    module.exports = BrowserUpgradeNotification;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/BrowserUpgradeNotification.js
 ** module id = 650
 ** module chunks = 0
 **/